import React from 'react';
import { Spinner } from 'react-bootstrap';
import { Cnt } from '../Cnt.ThreeDeeCrate.SDK/Cnt.ThreeDeeCrate.SDK';

interface Props {
  status: Cnt.ThreeDeeCrate.SDK.GenerationStatusType | null | undefined;
}

export const GenerationStatusBadge: React.FC<Props> = ({ status }) => {
  let text = '';
  let bgColor = 'bg-warning';
  let fgColor = 'text-dark';
  let showSpinner = false;

  switch (status) {
    case Cnt.ThreeDeeCrate.SDK.GenerationStatusType.ToBeGenerated:
      text = 'Pending';
      bgColor = 'bg-secondary';
      fgColor = 'text-dark';
      showSpinner = false;
      break;
    case Cnt.ThreeDeeCrate.SDK.GenerationStatusType.Queued:
      text = 'Queued';
      bgColor = 'bg-primary';
      fgColor = 'text-light';
      showSpinner = true;
      break;
    case Cnt.ThreeDeeCrate.SDK.GenerationStatusType.CreatingReference:
      text = 'Creating Reference';
      break;
    case Cnt.ThreeDeeCrate.SDK.GenerationStatusType.GeneratingMesh:
      text = 'Generating Mesh';
      break;
    case Cnt.ThreeDeeCrate.SDK.GenerationStatusType.GeneratingDiffuse:
      text = 'Generating Diffuse';
      break;
    case Cnt.ThreeDeeCrate.SDK.GenerationStatusType.GeneratingNormal:
      text = 'Generating Normal';
      break;
    case Cnt.ThreeDeeCrate.SDK.GenerationStatusType.UVUnwrapping:
      text = 'UV Unwrapping';
      break;
    case Cnt.ThreeDeeCrate.SDK.GenerationStatusType.GeneratingThumbnail:
      text = 'Generating Thumbnail';
      break;
    case Cnt.ThreeDeeCrate.SDK.GenerationStatusType.UploadingModel:
      text = 'Uploading Model';
      break;
    default:
      return null; // no badge for unknown or Done status
  }

  return text ? (
    <span
      className={`badge ${bgColor} ${fgColor}`}
      style={{
        position: 'absolute',
        top: '8px',
        right: '8px',
        padding: '5px 10px',
        fontSize: '0.8rem',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
      }}
    >
      {showSpinner && <Spinner animation="border" size="sm" />}
      {text}
    </span>
  ) : null;
};
